import React, { PureComponent, Fragment } from 'react';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Popover, Button, Radio, Divider, Input, Tooltip, Row, Col } from 'antd';
import withRouter from 'umi/withRouter';
import { connect } from 'dva';
import moment from 'moment';
import { makeSuppressObj, checkSuppression } from '../../../utils/suppressionHelper';
import SingleSignatureUnsuppress from './SingleSignatureUnsuppress';

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};

@connect(({ user, organisation, suppression, cloudAccount, regulations }) => ({
  supLoading: suppression.supLoading,
  cloudAccountList: cloudAccount.allCloudAccountsList,
  dbSuppressed: organisation.spRisks,
  currentUser: user.currentUser,
  currentRegulation: regulations.regulation,
}))
class SingleSignatureSuppress extends PureComponent {
  state = {
    visible: false,
    value: 'Not Applicable',
    next: false,
    inputVal: '',
    suppressLevel: '',
    step: 0,
  };

  componentDidUpdate = prevProps => {
    if (prevProps.supLoading === true && this.props.supLoading === false) {
      this.setState({
        visible: false,
      });
    }
  };

  render() {
    const { record } = this.props;

    const { suppress } = record;
    let title = !suppress ? 'Reason for Suppression?' : 'Suppression rule applied';

    return (
      <Popover
        placement="bottomRight"
        style={{ width: '40px' }}
        key={this.props.i}
        content={this.RenderContent()}
        title={
          <div>
            <div>{title}</div>
            <CloseOutlined
              style={{ float: 'right', marginTop: '-16px', fontSize: '15px' }}
              onClick={() => {
                this.setState({
                  visible: false,
                });
              }}
            />
          </div>
        }
        trigger="click"
        visible={this.state.visible === this.props.i}
      >
        <Tooltip
          placement="topLeft"
          title={!suppress ? 'Suppress Resource' : 'Unsuppress Resource'}
        >
          <EditOutlined
            style={{
              color: !suppress ? '#1E93FF' : '#777777',
              fontSize: 22,
              marginLeft: '16px',
            }}
            onClick={() => {
              this.setState({
                visible: this.props.i,
              });
            }}
          />
        </Tooltip>
      </Popover>
    );
  }

  suppressLevel = val => {
    this.setState({
      suppressLevel: val,
      step: this.state.step + 1,
      next: true,
    });
  };
  renderRegContent = () => {
    const { suppressLevel, step } = this.state;
    if (step === 0) {
      return (
        <Fragment>
          <p
            style={{
              marginBottom: '0px',
              cursor: 'pointer',
              backgroundColor: suppressLevel === 'global' ? '#E6F7FF' : '',
            }}
            onClick={() => {
              this.suppressLevel('global');
            }}
          >
            Globally
          </p>
          <Divider style={{ margin: '8px 0px' }} />
          <p
            style={{
              cursor: 'pointer',
              backgroundColor: suppressLevel === 'specific' ? '#E6F7FF' : '',
            }}
            onClick={() => {
              this.suppressLevel('specific');
            }}
          >
            Only in this report
          </p>
        </Fragment>
      );
    } else {
      return (
        <div style={{ width: '248px' }}>
          <Radio.Group onChange={this.onChange} value={this.state.value}>
            <Radio style={radioStyle} value="Not Applicable">
              Not Applicable
            </Radio>
            <Divider style={{ margin: '9px 0px' }} />
            <Radio style={radioStyle} value="Not in Scope">
              Not in Scope
            </Radio>
            <Divider style={{ margin: '9px 0px' }} />
            <Radio style={radioStyle} value={this.state.inputVal}>
              <Input
                onChange={this.onInput}
                placeholder="Other reason"
                style={{ width: '208px' }}
                type="text"
              />
            </Radio>
          </Radio.Group>
          <div style={{ textAlign: 'center', marginTop: '17px' }}>
            <Button onClick={this.cancel}>Cancel</Button>
            <Button
              loading={this.props.supLoading}
              onClick={this.saveSuppression}
              type="primary"
              style={{ marginLeft: '4px' }}
            >
              Save
            </Button>
          </div>
        </div>
      );
    }
  };
  RenderContent = () => {
    const { record, type, supLoading, currentRegulation } = this.props;

    let { suppress } = record;

    if (!suppress) {
      if (currentRegulation) {
        return this.renderRegContent();
      } else {
        return (
          <div style={{ width: '248px' }}>
            <Radio.Group
              onChange={e => {
                this.setState({
                  value: e.target.value,
                });
              }}
              value={this.state.value}
            >
              <Radio style={radioStyle} value="Not Applicable">
                Not Applicable
              </Radio>
              <Divider style={{ margin: '9px 0px' }} />
              <Radio style={radioStyle} value="Not in Scope">
                Not in Scope
              </Radio>
              <Divider style={{ margin: '9px 0px' }} />
              <Radio style={radioStyle} value={this.state.inputVal}>
                <Input
                  onChange={this.onInput}
                  placeholder="Other reason"
                  style={{ width: '208px' }}
                  type="text"
                />
              </Radio>
            </Radio.Group>
            <div style={{ textAlign: 'center', marginTop: '17px' }}>
              <Button
                onClick={() => {
                  this.setState({
                    visible: false,
                    next: false,
                    suppressLevel: '',
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                loading={supLoading}
                onClick={this.saveSuppression}
                type="primary"
                style={{ marginLeft: '4px' }}
              >
                Save
              </Button>
            </div>
          </div>
        );
      }
    } else {
      return (
        <SingleSignatureUnsuppress
          hidePopup={() => this.setState({ visible: false })}
          {...this.props}
        />
      );
    }
  };

  saveSuppression = () => {
    this.setState({
      visible: false,
    });
  };
}
export default SingleSignatureSuppress;
